import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { LocalesResolver } from 'core/resolvers';
import { CustomizationsComponent } from './customizations/customizations.component';
import { CustomizationCreateComponent } from './customization-create/customization-create.component';
import { CustomizationDetailComponent } from './customization-detail/customization-detail.component';
import { CustomizationResolver } from 'core/resolvers/customization.resolver';

export const customizationsRoutes: Routes = [
  {
    path: 'customizations',
    title: 'customizations.label',
    resolve: {
      locales: LocalesResolver
    },
    children: [
      {
        path: '',
        title: '',
        component: CustomizationsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'customizations.list', preloader: 'secondary' }
      },
      {
        path: 'new',
        title: 'customizations.create',
        component: CustomizationCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'customizations.create', preloader: 'secondary' }
      },
      {
        path: ':id',
        title: ':id',
        component: CustomizationDetailComponent,
        canActivate: [ProfileGuard],
        resolve: {
          customization: CustomizationResolver
        },
        data: { action: 'customizations.detail', preloader: 'secondary' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(customizationsRoutes)],
  exports: [RouterModule]
})
export class CustomizationsRoutingModule {}
